import { render, staticRenderFns } from "./chatConfigModal.vue?vue&type=template&id=396ce4a0&scoped=true&"
import script from "./chatConfigModal.vue?vue&type=script&lang=ts&"
export * from "./chatConfigModal.vue?vue&type=script&lang=ts&"
import style0 from "./chatConfigModal.vue?vue&type=style&index=0&id=396ce4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396ce4a0",
  null
  
)

export default component.exports